/**
 * @param {import('axios').AxiosInstance} apiClient
 * @param {object} body
 */
export const listDrives = async (apiClient, body) => {
  return apiClient.post('/v1/workspace/vault/list', body);
};
